import React, { useContext } from 'react'
import 'fontsource-roboto'
import './App.css'
import { ConfigContext, COIN,USDT,EUR,BUSD } from './context/ConfigProvider'
import RealtimeTable from './tables/RealtimeTable'
//import PriceSpreadTable from './tables/PriceSpreadTable'
import Collect from './components/Collect';


function Realtime() {

  const  { config, Styles } = useContext(ConfigContext)

  return (
    <Styles>
      <Collect name="realtime" />
      <br></br><br></br><br></br><br></br>
      <RealtimeTable title='BTC EUR' symbol='BTC' types={[EUR]} />
      {
        config.symbols.map((symbol) => (
          <React.Fragment key={symbol.symbol}>
            <br></br>
            <RealtimeTable title={symbol.symbol} symbol={symbol.symbol} types={[COIN,USDT,BUSD]} />
            <br></br>
          </React.Fragment>
        ))
      }
    </Styles>
  )
  
}

export default Realtime